import { Col, Row } from 'reactstrap';
import styles from './sales-force-asset-sync.module.scss';
import { Container, CreateHeaders, dateAndTimeHeader, HeaderSizeEnum, textHeader, Button, dateHeader, SnackBarContext, OrderTypesEnum } from '@frontend-workspace/react-shared-lib';
import PageTitle from '../page-title/page-title';
import { Box } from '@mui/material';
import WebkuaTable from '../webkua-table/webkua-table';
import { ValueFormatterParams } from 'ag-grid-community';
import { makeRequest, useGetRequestNewHook } from '../requestUtils';

import { useTranslation } from 'react-i18next';
import { GetCurrentCompany } from '../customer-context/customer-context';
import { Link } from 'react-router-dom';
import { useContext, useState } from 'react';
import { UseSignalRHook } from '../signalr-context/signalr-context';

/* eslint-disable-next-line */
export interface SalesForceAssetSyncProps { }

export function SalesForceAssetSync(props: SalesForceAssetSyncProps) {
  const currentCompany = GetCurrentCompany();
  const url = currentCompany ? `salesforce/assetChangeOrders/${currentCompany.number}` : "salesforce/assetChangeOrders/";
  const { data, getData }: { data: any[], getData: () => void, isLoading: boolean } = useGetRequestNewHook(url, undefined, [currentCompany]);
  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [isLoading, setIsLoading] = useState(false);

  const handleSignalRResponse = (response: any) => {
    getData();
    setIsLoading(false);
  }
  UseSignalRHook(handleSignalRResponse, [OrderTypesEnum.SFChangeAssetOrder]);
  const HandleRetryRenderer = (params: ValueFormatterParams) => {
    return <Button onClick={() => {
      handleRetryOrder(params.value);
    }
    } variant='contained' disabled={isLoading}>
      {t("salesForceAssetSync.sync")}
    </Button>
  }

  const handleRetryOrder = (id: string) => {
    setIsLoading(true);
    makeRequest(`admin/action/manuallyRunOrder/`, "PUT", {
      orderId: id,
      orderType: "SFChangeAssetOrder",
    }).then(() => {
      setSnackbarMessage({ content: t("salesForceAssetSync.syncing"), type: "success", })
    });
  }
  const handleSetAsManuallyHandled = (id: string) => {
    makeRequest(`orders/${id}/action/setToManuallyHandled`, 'PUT').then(() => {
      setSnackbarMessage({ content: t("salesForcAssetSync.manuallyHandled"), type: "success", })
      setIsLoading(false);
    });
  }

  const handleSetAsManuallyHandledRenderer = (params: ValueFormatterParams) => {
    return <Button onClick={() => {
      handleSetAsManuallyHandled(params.value)
    }} variant='contained' disabled={isLoading}>
      {t("salesForceAssetSync.setAsManuallyHandled")}
    </Button>
  }
  const contractNumberRenderer = (params: ValueFormatterParams) => {
    const url = `/customers/${params.data.companyNumber}/contracts/${params.data.contractNumber}`
    return <Link to={url}>{params.value}</Link>;
  }
  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}>
      <Row>
        <Col>
          <Box>
            <PageTitle title={t("app.assetSync")} subtitle='' />
            <WebkuaTable
              onRefresh={getData}
              headers={CreateHeaders([
                textHeader("id", t("standard.id"), HeaderSizeEnum.SMALL, { hide: true }),
                textHeader("itemId", t("salesForceAssetSync.itemId"), HeaderSizeEnum.SMALL),
                textHeader("productName", t("standard.productName")),
                textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.SMALL),
                textHeader("companyName", t("standard.companyName")),
                textHeader("licenseNumber", t("standard.licenseNumber"), HeaderSizeEnum.SMALL),
                textHeader("orderCount", t("salesForceAssetSync.orderCount"), HeaderSizeEnum.SMALL),
                textHeader("oldQuantity", t("salesForceAssetSync.oldQuantity"), HeaderSizeEnum.SMALL),
                textHeader("newQuantity", t("salesForceAssetSync.newQuantity"), HeaderSizeEnum.SMALL),
                dateAndTimeHeader("activationDate", t("standard.activationDate")),
                dateHeader("contractRenewalDate", t("salesForceAssetSync.contractRenewalDate")),
                textHeader("contractNumber", t("standard.contractNumber"), HeaderSizeEnum.SMALL, { renderer: contractNumberRenderer }),
                textHeader("changedBy", t("standard.changedBy")),
                textHeader("id", "", HeaderSizeEnum.SMALL, { renderer: HandleRetryRenderer }),
                textHeader("id", "", HeaderSizeEnum.MEDIUM, { renderer: handleSetAsManuallyHandledRenderer }),
              ])}
              data={data}
            />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default SalesForceAssetSync;
